import { STORE_CLEAR, STORE_CLEAR_FOR_DASHBOARD } from '../constants/storeTypes';

export function storeClear() {
  return { type: STORE_CLEAR };
}

export function storeClearForDashboard() {
  return { type: STORE_CLEAR_FOR_DASHBOARD };
}
